var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPenchartSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5H0V14.5H10V12.5ZM16 4.5H0V6.5H16V4.5ZM0 10.5H16V8.5H0V10.5ZM0 0.5V2.5H16V0.5H0Z",
    fill: "#2D2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPenchartSort);
export default __webpack_public_path__ + "static/media/ic-penchart-sort.31790dd69c9338d43ac7bcaa298fe51e.svg";
export { ForwardRef as ReactComponent };